import { useState } from "react";
import styled from "styled-components";
import Checkbox from "@material-ui/core/Checkbox";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import { withStyles } from '@material-ui/core/styles';
import Input from "./text-input";
const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#0ab23b',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CheckboxOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0;
`;

const CheckboxGroup = ({ options, onDelete, onUpdate }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (value) => {
    if (selectedOptions.includes(value)) {
      setSelectedOptions((prev) => prev.filter((option) => option !== value));
    } else {
      setSelectedOptions((prev) => [...prev, value]);
    }
  };

  return (
    <>
      {options?.map((option, index) => (
        <CheckboxOption key={index}>
          <GreenCheckbox
            checked={selectedOptions.includes(option.id)}
            onClick={() => handleChange(option.id)}
          />
          <Input
            width="330px"
            type="text"
            value={option.value}
            onChange={(e) => onUpdate(index, {...option, value: e.target.value})}
          />
          <DeleteIcon onClick={() => onDelete(index)} style={{ cursor: "pointer" }} />
        </CheckboxOption>
      ))}
    </>
  );
};

export default CheckboxGroup;
